import { memo } from 'react';
import { Navigate } from 'react-router-dom';
import { ChildrenProps } from '@dfl/mui-react-common';
import { useMfaEnrollmentRequired } from 'modules/authentication/hooks';

export const MFA_ENROLLMENT_PATH = '/mfa-setup';

const MfaEnrollmentGate = ({ children }: ChildrenProps) => {
  const { isRequired, isLoading } = useMfaEnrollmentRequired();

  if (isLoading || !isRequired) return <>{children}</>;

  return <Navigate to={MFA_ENROLLMENT_PATH} replace />;
};

export default memo(MfaEnrollmentGate);
